module.exports = __webpack_public_path__ + "img/65fd023.png";